/**
 * ImageCropper Styled Components - Created by Jesus Apodaca on 08/08/19.
 */
import styled from 'styled-components'
import { BLACK } from '../../theme/colors'

export const Text = styled.div`
  font-size: 14px;
  color: darkgray;
  width: 100%;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 18px;
`

export const RadioContainer = styled.div`
  .ant-radio-group {
    width: 100%;
    text-align: center;
  }
  .ant-radio-button-wrapper {
    background: #fafafa !important;
    border-color: #e8e8e8 !important;
  }
  .ant-radio-button-wrapper-checked {
    background: #C91731 !important;
    border-color: #C91731 !important;
  }
`

export const SaveButton = styled.div`
  width: 64px;
  background: #302628;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 48px;
  font-size: 14px;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.2s;
  &#skipBtn {
    margin-right: 18px;
    color: #302628;
    background-color: #fff;
    border: 1px solid #302628;
  }
  &:hover {
    color: ${BLACK};
    background: white;
  }
`

export const CropperContainer = styled.div<{secondary?: boolean}>`
  height: 50vh;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: ${({ secondary }) => secondary ? '10px' : '30px'};
`

export const Loader = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  background: #ffffffb0;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ImageCropper/styledComponents.tsx